export default __webpack_public_path__ + "static/media/RoutePage1.77dc4405.txt";